/* Solaura Auto-Animate
   Scans the page for common Solaura section patterns and applies
   scroll-triggered fade/rise/slide animations. Zero per-page setup. */
(function () {
  // Respect users who opt out of motion
  const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Inject CSS once
  const css = `
    .a-reveal { opacity: 0; transform: translateY(28px); transition: opacity 0.9s ease, transform 0.9s cubic-bezier(0.2, 0.7, 0.2, 1); }
    @media (prefers-reduced-motion: reduce) {
      .a-reveal, .a-reveal.in-view { opacity: 1 !important; transform: none !important; transition: none !important; }
    }
    .a-reveal.in-view { opacity: 1; transform: translateY(0); }
    .a-reveal--left { transform: translateX(-40px); }
    .a-reveal--left.in-view { transform: translateX(0); }
    .a-reveal--right { transform: translateX(40px); }
    .a-reveal--right.in-view { transform: translateX(0); }
    .a-reveal--scale { transform: scale(0.94); }
    .a-reveal--scale.in-view { transform: scale(1); }
    .a-d1 { transition-delay: 0.08s; }
    .a-d2 { transition-delay: 0.16s; }
    .a-d3 { transition-delay: 0.24s; }
    .a-d4 { transition-delay: 0.32s; }
    .a-d5 { transition-delay: 0.40s; }
    .a-d6 { transition-delay: 0.48s; }
    .a-d7 { transition-delay: 0.56s; }
    .a-d8 { transition-delay: 0.64s; }
  `;
  const style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  function tag(el, cls) {
    if (!el) return;
    el.classList.add('a-reveal');
    if (cls) el.classList.add(cls);
  }

  function tagStagger(els, extraClass) {
    Array.from(els).slice(0, 8).forEach((el, i) => {
      el.classList.add('a-reveal');
      if (extraClass) el.classList.add(extraClass);
      if (i > 0) el.classList.add('a-d' + Math.min(i, 8));
    });
  }

  function ready() {
    // Skip these — they should appear instantly or are interactive
    const SKIP = /(warn|warning|faq|legal|announce|spec|table|footer|buy|price|variant|form|nav|header)/i;

    // 1. Heading lines — eyebrow, title, sub (stagger them within their container)
    const headGroups = document.querySelectorAll(
      'section, .hero, [class*="hero"], [class*="__head"], [class*="-head"]'
    );
    headGroups.forEach(group => {
      if (SKIP.test(group.className)) return;
      const eyebrow = group.querySelector('[class*="eyebrow"]');
      const title = group.querySelector('h1, h2, [class*="title"]:not([class*="card"]):not([class*="item"])');
      const sub = group.querySelector('[class*="sub"], [class*="desc"]:not([class*="card"]):not([class*="item"])');
      if (eyebrow) tag(eyebrow);
      if (title) { tag(title); title.classList.add('a-d1'); }
      if (sub) { tag(sub); sub.classList.add('a-d2'); }
    });

    // 2. Statement blocks — big serif sentences
    document.querySelectorAll('[class*="statement"] p, [class*="stmt"] p').forEach(p => tag(p));

    // 3. Feature split blocks — image one side, copy other
    document.querySelectorAll('[class*="feat"], [class*="hero-block"]').forEach(feat => {
      if (SKIP.test(feat.className)) return;
      const media = feat.querySelector('[class*="media"]');
      const copy = feat.querySelector('[class*="copy"]');
      const isReverse = /reverse/.test(feat.className);
      if (media) tag(media, isReverse ? 'a-reveal--right' : 'a-reveal--left');
      if (copy) tag(copy, isReverse ? 'a-reveal--left' : 'a-reveal--right');
    });

    // 4. Card grids — stagger the children
    document.querySelectorAll(
      '[class*="grid"]:not([class*="__head"]):not([class*="-head"])'
    ).forEach(grid => {
      if (SKIP.test(grid.className)) return;
      // Only stagger direct children that look like cards/items (2+ of them)
      const kids = Array.from(grid.children).filter(c => c.tagName !== 'SCRIPT');
      if (kids.length >= 2 && kids.length <= 12) {
        tagStagger(kids);
      }
    });

    // 5. CTA sections — scale on heading + button
    document.querySelectorAll('[class*="cta"]:not(a)').forEach(cta => {
      if (SKIP.test(cta.className)) return;
      const h = cta.querySelector('h1, h2, [class*="heading"]');
      const p = cta.querySelector('p:not([class*="eyebrow"])');
      const btn = cta.querySelector('a.btn, [class*="btn"]');
      if (h) tag(h, 'a-reveal--scale');
      if (p) { tag(p, 'a-reveal--scale'); p.classList.add('a-d1'); }
      if (btn) { tag(btn, 'a-reveal--scale'); btn.classList.add('a-d2'); }
    });

    // 6. Scent library / chip rows — stagger
    document.querySelectorAll('[class*="scents__row"], [class*="scents__grid"]').forEach(row => {
      tagStagger(row.children);
    });

    // Kick off the observer
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    document.querySelectorAll('.a-reveal').forEach(el => io.observe(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
